document.addEventListener('DOMContentLoaded', () => {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SLIDE_BASE = 150;
  const SLIDE_STAGGER = 180;
  const SLIDE_DURATION = 750;
  const COUNT_DURATION = 1100;
  const COUNT_STAGGER = 120;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function prepareCounters(root) {
    root.querySelectorAll('[data-sr-count]').forEach((el) => {
      const finalText = el.textContent.trim();
      el.dataset.srFinal = finalText;
      el.textContent = finalText.replace(/\d+/g, '0');
    });
  }

  function runCounter(el, delay) {
    const finalText = el.dataset.srFinal || el.textContent;
    const parts = finalText.split(/(\d+)/);
    let start = null;

    function frame(now) {
      if (start === null) start = now;
      const progress = Math.min((now - start) / COUNT_DURATION, 1);
      const eased = easeOutCubic(progress);
      el.textContent = parts
        .map((part) => (/^\d+$/.test(part) ? Math.round(parseInt(part, 10) * eased).toString() : part))
        .join('');
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = finalText;
      }
    }

    setTimeout(() => requestAnimationFrame(frame), delay);
  }

  function showFinalState(root) {
    root.classList.add('is-static', 'is-inview', 'is-stats');
    root.querySelectorAll('[data-sr-count]').forEach((el) => {
      if (el.dataset.srFinal) el.textContent = el.dataset.srFinal;
    });
  }

  function startSequence(root) {
    root.classList.add('is-inview');

    const cards = root.querySelectorAll('[data-sr-card]');
    let maxOrder = 0;
    cards.forEach((card) => {
      const order = parseInt(getComputedStyle(card).getPropertyValue('--sr-order'), 10) || 0;
      if (order > maxOrder) maxOrder = order;
    });

    const phaseTwoDelay = SLIDE_BASE + maxOrder * SLIDE_STAGGER + SLIDE_DURATION;

    setTimeout(() => {
      root.classList.add('is-stats');
      root.querySelectorAll('[data-sr-card]').forEach((card) => {
        const order = parseInt(getComputedStyle(card).getPropertyValue('--sr-order'), 10) || 1;
        const delay = (order - 1) * COUNT_STAGGER;
        card.querySelectorAll('[data-sr-count]').forEach((el) => runCounter(el, delay));
      });
    }, phaseTwoDelay);
  }

  function initSection(root) {
    if (root.dataset.srInit) return;
    root.dataset.srInit = 'true';

    if (REDUCED_MOTION || (window.Shopify && window.Shopify.designMode)) {
      showFinalState(root);
      return;
    }

    prepareCounters(root);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          startSequence(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sych-first-results]').forEach(initSection);
  }

  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
});
